import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import HighlightText from './HighlightText';
import SubjectTutorsModal from './SubjectTutorsModal';

const subjects = [
  { icon: FiIcons.FiGrid, title: 'Mathematics', desc: 'Algebra, Calculus & More', color: 'bg-blue-50', iconColor: 'text-blue-500' },
  { icon: FiIcons.FiActivity, title: 'Science', desc: 'Physics, Chemistry, Bio', color: 'bg-green-50', iconColor: 'text-green-500' },
  { icon: FiIcons.FiBookOpen, title: 'English', desc: 'Grammar & Literature', color: 'bg-purple-50', iconColor: 'text-purple-500' },
  { icon: FiIcons.FiPieChart, title: 'Commerce', desc: 'Accounts & Economics', color: 'bg-orange-50', iconColor: 'text-orange-500' },
  { icon: FiIcons.FiUser, title: 'Junior Wing', desc: 'Class 1 to 5 All Subjects', color: 'bg-pink-50', iconColor: 'text-pink-500' },
  { icon: FiIcons.FiAward, title: 'High School', desc: 'Class 6 to 10', color: 'bg-indigo-50', iconColor: 'text-indigo-500' },
  { icon: FiIcons.FiLayers, title: 'Intermediate', desc: 'Class 11 & 12 Specialized', color: 'bg-teal-50', iconColor: 'text-teal-500' },
  { icon: FiIcons.FiMonitor, title: 'Coding / IT', desc: 'Python, Java, C++', color: 'bg-red-50', iconColor: 'text-primary' },
];

const SubjectsSection = () => {
  const [selectedSubject, setSelectedSubject] = useState(null);

  return (
    <>
      <section className="py-24 bg-[#fdf8f4]" id="subjects">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-red-50 text-primary text-xs font-bold px-4 py-2 rounded-full mb-4 border border-red-100 uppercase tracking-widest">
              <FiIcons.FiBookOpen className="w-3.5 h-3.5" />
              Curriculum
            </div>
            <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 tracking-tight mb-4">
              Popular <HighlightText>Subjects</HighlightText>
            </h2>
            <p className="text-gray-500 font-medium max-w-2xl mx-auto">
              Click on any subject to explore expert tutors available for that topic.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {subjects.map((sub, idx) => (
              <button
                key={idx}
                onClick={() => setSelectedSubject(sub.title)}
                className="bg-white rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col items-center text-center group hover:-translate-y-1 cursor-pointer w-full"
              >
                <div className={`w-16 h-16 ${sub.color} rounded-2xl flex items-center justify-center mb-5 group-hover:bg-primary transition-colors duration-300 shadow-sm`}>
                  <sub.icon className={`w-7 h-7 ${sub.iconColor} group-hover:text-white transition-colors duration-300`} />
                </div>
                <h3 className="text-lg font-extrabold text-slate-900 mb-2 tracking-tight">{sub.title}</h3>
                <p className="text-sm font-medium text-gray-500 mb-3">{sub.desc}</p>
                <span className="text-xs font-bold text-primary bg-red-50 px-3 py-1 rounded-full border border-red-100 group-hover:bg-primary group-hover:text-white transition-colors duration-300">
                  View Tutors →
                </span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {selectedSubject && (
        <SubjectTutorsModal
          subject={selectedSubject}
          onClose={() => setSelectedSubject(null)}
        />
      )}
    </>
  );
};

export default SubjectsSection;